import React, { useEffect, useState } from 'react';

import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { ToolBar } from 'components/common/ToolBar';
import { useArtworkDrawer } from 'contexts/ArtworkDrawerContext';
import { OverlayDrawer } from 'components/common/drawer/OverlayDrawer';

export const ArtworkLayout = () => {
  const { drawer, closeDrawer } = useArtworkDrawer();
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    if (drawer.show) {
      setShowOverlay(true);
    } else {
      const timer = setTimeout(() => setShowOverlay(false), 250);
      return () => clearTimeout(timer);
    }
  }, [drawer.show]);

  return (
    <Box sx={{ width: '100%', height: '100vh', marginTop: '2px' }}>
      <ToolBar />
      <Box
        component="main"
        sx={{
          height: '100%',
          alignItems: 'center',
        }}
      >
        <Outlet />
      </Box>
      {showOverlay && (
        <Box
          onClick={drawer.allowClickOutsideClose ? closeDrawer : undefined}
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 1200,
            backgroundColor: 'transparent',
          }}
        />
      )}
      <OverlayDrawer
        open={drawer.show}
        component={drawer.component}
        close={closeDrawer}
        allowClickOutsideClose={drawer.allowClickOutsideClose}
      />
    </Box>
  );
};
